export { default as CallAudioDownloadButton } from '@/views/pages/call/components/CallAudioDownloadButton.vue';
export { default as CallChatBot } from '@/views/pages/call/components/CallChatBot.vue';
export { default as CallDetails } from '@/views/pages/call/components/CallDetails.vue';
export { default as CallListFilters } from '@/views/pages/call/components/CallListFilters.vue';
export { default as CallListSort } from '@/views/pages/call/components/CallListSort.vue';
export { default as CallPlayer } from '@/views/pages/call/components/CallPlayer.vue';
export { default as CallPlayerBullets } from '@/views/pages/call/components/CallPlayerBullets.vue';
export { default as CallSurvey } from '@/views/pages/call/components/CallSurvey.vue';
export { default as CallWords } from '@/views/pages/call/components/CallWords.vue';
